"use client";

import { ColumnDef } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Badge } from "@/components/ui/badge"; // Pastikan import Badge

import { ArrowUpDown } from "lucide-react";
import Actions from "./Actions";
import { SysBerkasPortofolio } from "@/types";

export const columns: ColumnDef<SysBerkasPortofolio>[] = [
  {
    id: "select",
    header: ({ table }) => (
      <Checkbox
        checked={
          table.getIsAllPageRowsSelected() ||
          (table.getIsSomePageRowsSelected() && "indeterminate")
        }
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "bidang",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Bidang
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      );
    },
    cell: ({ row }) => {
      const bidang = row.original.bidang;
      return (
        <span className="capitalize font-medium">{bidang ? bidang : "-"}</span>
      );
    },
  },
  {
    accessorKey: "nama_jenis_berkas",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Nama Berkas
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      );
    },
    cell: ({ row }) => (
      <span className="font-semibold text-slate-700 dark:text-slate-300">
        {row.original.nama_jenis_berkas}
      </span>
    ),
  },
  {
    accessorKey: "keterangan_berkas",
    header: "Keterangan",
    cell: ({ row }) => (
      <span
        className="line-clamp-2 max-w-[250px] text-sm text-muted-foreground"
        title={row.original.keterangan_berkas}
      >
        {row.original.keterangan_berkas || "-"}
      </span>
    ),
  },
  {
    accessorKey: "extension_allowed",
    header: "Ekstensi",
    cell: ({ row }) => {
      const extensions = row.original.extension_allowed;
      return (
        <div className="flex flex-wrap gap-1">
          {extensions?.length > 0 ? (
            extensions.map((ext, index) => (
              <Badge
                key={index}
                variant="outline"
                className="text-[10px] uppercase"
              >
                {ext}
              </Badge>
            ))
          ) : (
            <span className="text-muted-foreground">-</span>
          )}
        </div>
      );
    },
  },
  {
    accessorKey: "max_upload",
    header: "Max Size (MB)",
    cell: ({ row }) => {
      const maxUploadKb = row.original.max_upload;

      if (!maxUploadKb) return <span className="text-slate-400">-</span>;

      const maxUploadMb = maxUploadKb / 1024;

      return (
        <span className="text-sm font-medium">
          {maxUploadMb >= 1
            ? `${Number(maxUploadMb.toFixed(1))} MB`
            : `${maxUploadKb} KB`}
        </span>
      );
    },
  },
  {
    accessorKey: "is_active",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Status
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      );
    },
    cell: ({ row }) => {
      const isActive = row.original.is_active;
      return isActive ? (
        <Badge className="bg-emerald-100 text-emerald-700 hover:bg-emerald-100 dark:bg-emerald-900/30 dark:text-emerald-400 border-transparent shadow-none">
          Aktif
        </Badge>
      ) : (
        <Badge variant="outline" className="text-slate-500">
          Nonaktif
        </Badge>
      );
    },
  },
  {
    id: "actions",
    cell: ({ row }) => {
      return <Actions row={row.original} />;
    },
  },
];
